"use strict";exports.__esModule = true;var checkIsNewProperty = exports.checkIsNewProperty = function checkIsNewProperty(createdDateString, todayDate) {
  var createdDate = new Date(createdDateString);
  var fortyEightHours = 259200000;
  return todayDate - createdDate < fortyEightHours;
};

var parseDate = function parseDate(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  var day = date.getDay();

  return { year: year, month: month, day: day };
};

var checkIsPublishedToday = exports.checkIsPublishedToday = function checkIsPublishedToday(createdDateString, todayDate) {
  var createdDate = new Date(createdDateString);
  var parsedCreatedDate = parseDate(createdDate);
  var parsedTodayDate = parseDate(todayDate);

  return Object.keys(parsedCreatedDate).every(function (key) {return parsedCreatedDate[key] === parsedTodayDate[key];});
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/checkIsNewProperty.js
// module id = 292
// module chunks = 0